export default __webpack_public_path__ + "static/media/BecomePartnerBg.2b8d720a.png";